module.exports = __webpack_public_path__ + "static/media/data-form-search-history-logo.d5eb1562.png";